import React from "react";
import _ from "lodash";
import { FiArrowDown } from "react-icons/fi";
import GoToInsightButton from "../../common/GoToInsightButton";
import NumberFormat from "../../common/NumberFormat";
import AdUnitBasicCard from "../../snapshot/AdUnitBasicCard";
import PopupWrapper from "../../common/PopupWrapper";
import ClickToCopyWrapper from "../../common/ClickToCopyWrapper";
import UnitMode from "../../common/UnitMode";
import {
  CHECK_STATUS,
  EVAL_KEYS,
  KEY_FORMAT,
} from "../../../constants/HealthCheck";

class UnitsCheckSummaryTable extends React.PureComponent {
  constructor(props) {
    super(props);

    const { reports, overviewEvalKey, checkNameFilter, checkStatusFilter } =
      props;
    const sortKey = overviewEvalKey;
    const statusFilterKey = checkStatusFilter;
    const checkFilterKey = checkNameFilter;

    const { filteredReports, checks, unitReports } = this._transformReports(
      reports,
      statusFilterKey,
      checkFilterKey,
      sortKey
    );

    this.state = {
      sortKey,
      statusFilterKey,
      checkFilterKey,
      countOnlyKeys: null, // array of checks or null (ALL)

      unitReports,
      filteredReports,

      checks,
      selectedUnitIds: [],

      isFixedPopup: false,
    };

    this.handleSortKeyChanged = this.handleSortKeyChanged.bind(this);
    this.handleStatusFilterChanged = this.handleStatusFilterChanged.bind(this);
    this.handleCheckFilterChanged = this.handleCheckFilterChanged.bind(this);
    this.filterReports = this.filterReports.bind(this);
    this.handleCountOnlyFilterChanged =
      this.handleCountOnlyFilterChanged.bind(this);
    this.handleSelectUnit = this.handleSelectUnit.bind(this);

    this.handleChangePopupFixed = this.handleChangePopupFixed.bind(this);
  }

  componentDidUpdate(prevProps) {
    // console.log("did update", prevProps, this.props);
    if (
      prevProps.checkNameFilter !== this.props.checkNameFilter ||
      prevProps.checkStatusFilter !== this.props.checkStatusFilter
    ) {
      const { unitReports } = this.state;
      const { checkNameFilter, checkStatusFilter } = this.props;
      console.log("check filter changed", checkNameFilter, checkStatusFilter);
      let filteredReports = this.filterReports(
        unitReports,
        checkStatusFilter,
        checkNameFilter
      );
      filteredReports = this.sortReports(filteredReports, this.state.sortKey);

      this.setState({
        filteredReports,
        statusFilterKey: checkStatusFilter,
        checkFilterKey: checkNameFilter,
        // sortKey: checkStatusFilter,
      });
    }

    if (
      prevProps.ysFilter === this.props.ysFilter &&
      prevProps.inspFilter === this.props.inspFilter &&
      prevProps.reqTypeFilter === this.props.reqTypeFilter &&
      prevProps.onboardTimeFilter === this.props.onboardTimeFilter &&
      prevProps.susModeFilter === this.props.susModeFilter &&
      prevProps.debugModeFilter === this.props.debugModeFilter
    ) {
      return;
    } else {
      console.log("filter changed", this.props.reports);
      const { filteredReports, checks, unitReports } = this._transformReports(
        this.props.reports,
        this.state.statusFilterKey,
        this.state.checkFilterKey,
        this.state.sortKey
      );

      this.setState({ filteredReports, checks, unitReports });
    }
  }

  _transformReports(reports, statusFilterKey, checkFilterKey, sortKey) {
    let checks = _.map(reports[0].check_results, "name").sort();
    let unitReports = _.map(reports, (report) => {
      report.summary = _.countBy(report.check_results, "result");
      report.csMap = _.groupBy(report.check_results, "result");
      return report;
    });

    let filteredReports = this.filterReports(
      reports,
      statusFilterKey,
      checkFilterKey
    );
    filteredReports = this.sortReports(filteredReports, sortKey);
    return {
      filteredReports,
      checks,
      unitReports,
    };
  }

  handleSortKeyChanged(sortKey) {
    const filteredReports = this.sortReports(
      this.state.filteredReports,
      sortKey
    );
    this.setState({ sortKey, filteredReports });
  }

  handleStatusFilterChanged(cs) {
    if (cs === this.state.statusFilterKey) return;

    this.props.filterUnitsReports(this.state.checkFilterKey, cs);
  }

  handleCheckFilterChanged(c) {
    if (c === this.state.checkFilterKey) return;

    this.props.filterUnitsReports(c, this.state.statusFilterKey);
  }

  handleChangePopupFixed(value) {
    this.setState({ isFixedPopup: value });
  }

  sortReports(reports, sortKey) {
    const filteredReports = _.orderBy(reports, _orderFn, "desc");
    function _orderFn(r) {
      if (_.includes(CHECK_STATUS, sortKey)) {
        return r.summary[sortKey] || -99999;
      }

      return r.stat[sortKey] || -99999;
    }
    return filteredReports;
  }

  filterReports(reports, cs, checkName) {
    if (checkName === "ALL") {
      checkName = null;
    }
    if (cs === "ALL") {
      cs = null;
    }
    let filteredReports = _.filter(reports, (r) => {
      return _.find(r.check_results, (cr) => {
        if (cs && checkName) {
          return cr.name === checkName && cr.result === cs;
        }
        if (cs) {
          return cr.result === cs;
        }
        if (checkName) {
          return cr.name === checkName;
        }
        return true;
      });
    });
    return filteredReports;
  }

  _recountCheckCounts(reports, countOnlyKeys) {
    let unitReports = _.map(reports, (report) => {
      let checkResults = [];
      if (!countOnlyKeys) {
        checkResults = report.check_results;
      } else {
        checkResults = _.filter(report.check_results, (r) => {
          return _.includes(countOnlyKeys, r.name);
        });
      }
      report.summary = _.countBy(checkResults, "result");
      return report;
    });

    return unitReports;
  }

  handleCountOnlyFilterChanged(check) {
    if (check === "ALL") {
      let unitReports = this._recountCheckCounts(this.state.unitReports, null);
      return this.setState({ countOnlyKeys: null, unitReports });
    }

    const { countOnlyKeys } = this.state;
    let keys = [];
    if (!countOnlyKeys) {
      keys.push(check);
    } else {
      const isPreviouslySelected = _.includes(countOnlyKeys, check);
      if (isPreviouslySelected) {
        // remove from list
        keys = _.filter(countOnlyKeys, (k) => {
          return k !== check;
        });
      } else {
        // add to list
        keys = [...countOnlyKeys, check];
      }

      if (keys.length === 0) {
        keys = null;
      }
    }

    let unitReports = this._recountCheckCounts(this.state.unitReports, keys);
    this.setState({ countOnlyKeys: keys, unitReports });
  }

  handleSelectUnit(unitId) {
    if (unitId === "ALL") {
      let newUnits = _.map(this.state.filteredReports, (u) => {
        return u.unit_id;
      });
      this.setState({ selectedUnitIds: newUnits });
      return;
    }

    const { selectedUnitIds } = this.state;
    let newUnits = [];
    if (_.includes(selectedUnitIds, unitId)) {
      newUnits = _.filter(selectedUnitIds, (uid) => {
        return uid !== unitId;
      });
    } else {
      newUnits = [...selectedUnitIds, unitId];
    }
    this.setState({ selectedUnitIds: newUnits });
  }

  render() {
    const {
      sortKey,
      statusFilterKey,
      checkFilterKey,
      countOnlyKeys,
      filteredReports,
      checks,
      selectedUnitIds,
      isFixedPopup,
    } = this.state;
    const { overviewEvalKey, snapshotsByUnitId, networkInfo } = this.props;

    return (
      <div>
        <div className="border mb-2 px-2 py-2">
          <div className="mb-2 text-sm font-semibold">
            Filter check status:{" "}
            <button
              type="button"
              className={`rounded mr-1 px-2 py-1 font-semibold ${
                statusFilterKey === "ALL"
                  ? "bg-indigo-100 text-indigo-800"
                  : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
              }`}
              onClick={() => this.handleStatusFilterChanged("ALL")}
            >
              ALL
            </button>
            {CHECK_STATUS.map((cs) => {
              return (
                <button
                  key={cs}
                  type="button"
                  className={`rounded mr-1 px-2 py-1 font-semibold ${
                    statusFilterKey === cs
                      ? "bg-indigo-100 text-indigo-800"
                      : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
                  }`}
                  onClick={() => this.handleStatusFilterChanged(cs)}
                >
                  {cs}
                </button>
              );
            })}
          </div>
          <div className="border-t mt-1 pt-1 text-sm font-semibold">
            Filter check:{" "}
            <button
              type="button"
              className={`rounded mr-1 px-2 py-1 font-semibold ${
                checkFilterKey === "ALL"
                  ? "bg-indigo-100 text-indigo-800"
                  : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
              }`}
              onClick={() => this.handleCheckFilterChanged("ALL")}
            >
              ALL
            </button>
            <div>
              {checks.map((c) => {
                return (
                  <button
                    key={c}
                    type="button"
                    className={`rounded mr-1 px-2 py-1 font-semibold ${
                      checkFilterKey === c
                        ? "bg-indigo-100 text-indigo-800"
                        : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
                    }`}
                    onClick={() => this.handleCheckFilterChanged(c)}
                  >
                    {c}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="border-t mt-1 pt-1 text-sm font-semibold">
            Count ONLY:{" "}
            <button
              type="button"
              className={`rounded mr-1 px-2 py-1 font-semibold ${
                countOnlyKeys === null
                  ? "bg-pink-100 text-pink-800"
                  : "text-gray-700 hover:bg-gray-200 hover:text-pink-800"
              }`}
              onClick={() => this.handleCountOnlyFilterChanged("ALL")}
            >
              ALL
            </button>
            <div>
              {checks.map((c) => {
                return (
                  <button
                    key={c}
                    type="button"
                    className={`rounded mr-1 px-2 py-1 font-semibold ${
                      _.includes(countOnlyKeys, c)
                        ? "bg-pink-100 text-pink-800"
                        : "text-gray-700 hover:bg-gray-200 hover:text-pink-800"
                    }`}
                    onClick={() => this.handleCountOnlyFilterChanged(c)}
                  >
                    {c}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* <div>
          statusFilterKey: {statusFilterKey}
          <br />
          checkFilterKey: {checkFilterKey}
          <br />
          countOnlyKeys: {countOnlyKeys}
          <br />
        </div> */}

        <div className="italic text-gray-800">
          Showing <b>{filteredReports.length}</b> out of{" "}
          {this.props.reports.length} units
        </div>

        <table
          className="border shadow table w-full text-sm"
          style={{ marginBottom: "500px" }}
        >
          <thead className="border-b bg-gray-200 text-xs text-blue-800">
            <tr>
              <th className="pl-2">
                <input
                  style={{
                    width: "18px",
                    height: "18px",
                    marginTop: "4px",
                  }}
                  type="checkbox"
                  checked={selectedUnitIds.length === filteredReports.length}
                  onChange={() => this.handleSelectUnit("ALL")}
                ></input>
              </th>
              <th></th>
              <th></th>
              <th className="border px-2 py-1">Unit</th>

              <th className="border px-2 py-1 text-center">
                <div
                  className={`${
                    sortKey === overviewEvalKey
                      ? "text-gray-800"
                      : "text-gray-200"
                  }
                      flex cursor-pointer items-center justify-center gap-1 hover:text-gray-600
                    `}
                  onClick={() => this.handleSortKeyChanged(overviewEvalKey)}
                >
                  <FiArrowDown></FiArrowDown>
                  <span className="pr-2 text-blue-800">{overviewEvalKey}</span>
                </div>
                {/* <div className="text-xs">{EVAL_KEYS[overviewEvalKey].sec}</div> */}
              </th>

              {CHECK_STATUS.map((cs) => {
                return (
                  <th key={cs} className="border px-2 py-1 text-center">
                    <div
                      className={`${
                        sortKey === cs ? "text-gray-800" : "text-gray-200"
                      }
                      flex cursor-pointer items-center justify-center gap-1 hover:text-gray-600
                    `}
                      onClick={() => this.handleSortKeyChanged(cs)}
                    >
                      <FiArrowDown></FiArrowDown>
                      <span className="pr-2 text-blue-800">{cs}</span>
                    </div>
                  </th>
                );
              })}

              <th className="border px-2 py-1 text-center">Failed Checks</th>
              <th className="border px-2 py-1 text-center">NMD Checks</th>
            </tr>
          </thead>
          <tbody className="bg-white font-mono text-gray-900">
            {filteredReports &&
              filteredReports.map((r, i) => {
                return (
                  <tr key={r.unit_id} className="border-b hover:bg-gray-100">
                    <td className="pl-2">
                      <input
                        style={{
                          width: "18px",
                          height: "18px",
                          marginTop: "4px",
                        }}
                        type="checkbox"
                        checked={selectedUnitIds.indexOf(r.unit_id) !== -1}
                        onChange={() => this.handleSelectUnit(r.unit_id)}
                      ></input>
                    </td>
                    <td className="pr-2 text-right text-gray-600">{i + 1}</td>
                    <td className="border px-1">
                      <GoToInsightButton
                        unitId={r.unit_id}
                        qp="?tab=HEALTH_CHECK"
                        showIconOnly={true}
                      ></GoToInsightButton>
                    </td>
                    <td className="whitespace-no-wrap border px-2 py-1 font-sans font-semibold">
                      <div className="flex items-center gap-2">
                        <PopupWrapper
                          place="bottom left"
                          hideArrow={true}
                          isFixed={isFixedPopup}
                          triggerElement={
                            <button
                              type="button"
                              className="border-b border-gray-600"
                            >
                              {r.unit_id}{" "}
                              <span className="mr-1 text-gray-700">
                                {r.unit_name}
                              </span>
                              {r.isInsp && (
                                <span className="rounded bg-orange-400 px-2 text-xs font-bold text-orange-100">
                                  INSP
                                </span>
                              )}
                              {r.isDebug && (
                                <span className="rounded bg-pink-500 px-2 text-xs font-bold text-pink-100">
                                  DEBUG
                                </span>
                              )}
                              {r.hasGpt && (
                                <span className="rounded bg-indigo-100 px-2 text-xs text-gray-600">
                                  GPT
                                </span>
                              )}
                              {r.hasAmp && (
                                <span className="rounded bg-indigo-100 px-2 text-xs text-gray-600">
                                  AMP
                                </span>
                              )}
                            </button>
                          }
                          popupElement={
                            <div
                              className="overflow-y-auto border-4 border-gray-600 shadow-lg"
                              style={{ marginTop: "-9px", maxHeight: "500px" }}
                            >
                              {snapshotsByUnitId[r.unit_id] ? (
                                <AdUnitBasicCard
                                  networkId={networkInfo.gamNetworkId}
                                  networkName={networkInfo.name}
                                  unit={snapshotsByUnitId[r.unit_id]}
                                  showFullWidthCard={false}
                                  isCompactMode={false}
                                  handleCloseModal={() =>
                                    this.handleChangePopupFixed(false)
                                  }
                                  handleOpenModal={() =>
                                    this.handleChangePopupFixed(true)
                                  }
                                ></AdUnitBasicCard>
                              ) : (
                                <div>No snapshot</div>
                              )}
                            </div>
                          }
                        ></PopupWrapper>
                        <UnitMode unit={r}></UnitMode>
                      </div>

                      <div className="text-xs font-normal text-gray-600">
                        {r.ysId} {r.ysName}
                      </div>
                    </td>
                    <td className="whitespace-no-wrap border px-3 py-1 text-right">
                      <div className="flex flex-row-reverse items-center justify-start gap-2">
                        <NumberFormat
                          value={r.stat[overviewEvalKey]}
                          format={KEY_FORMAT[overviewEvalKey]}
                        ></NumberFormat>
                        <div className="text-xs font-normal text-gray-600">
                          <NumberFormat
                            value={r.stat[EVAL_KEYS[overviewEvalKey].sec]}
                            format={KEY_FORMAT[EVAL_KEYS[overviewEvalKey].sec]}
                          ></NumberFormat>
                        </div>
                      </div>
                    </td>

                    {CHECK_STATUS.map((cs) => {
                      return (
                        <td key={cs} className="border px-2 py-1 text-center">
                          <span
                            className="px-2"
                            data-tip
                            data-for={`${cs}-${r.unit_id}-cc`}
                          >
                            {r.summary[cs]}
                          </span>
                          {/* Very bad performance with tooltip added... */}
                          {/* {r.csMap[cs] && (
                          <ReactTooltip
                            id={`${cs}-${r.unit_id}-cc`}
                            type="dark"
                            effect="solid"
                            place={"top"}
                          >
                            {r.csMap[cs].map((cc) => {
                              return <div key={cc.name}>{cc.name}</div>;
                            })}
                          </ReactTooltip>
                        )} */}
                        </td>
                      );
                    })}

                    <td className="border px-2 py-1 text-left text-xs text-gray-700">
                      {r.csMap["FAIL"] &&
                        r.csMap["FAIL"].map((cc, index) => {
                          return (
                            <div key={cc.name} className="whitespace-no-wrap">
                              {index + 1}: {cc.name}
                            </div>
                          );
                        })}
                    </td>

                    <td className="border px-2 py-1 text-left text-xs text-gray-700">
                      {r.csMap["NEED_MORE_DATA"] &&
                        r.csMap["NEED_MORE_DATA"].map((cc, index) => {
                          return (
                            <div key={cc.name} className="whitespace-no-wrap">
                              {index + 1}: {cc.name}
                            </div>
                          );
                        })}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        <div className="fixed bottom-0 left-0 w-full border-t-2 bg-white px-4 py-2">
          <div className="flex items-center gap-2 text-gray-700">
            <div className="w-48 text-right text-sm">
              Selected Units ({selectedUnitIds.length}):
            </div>
            <textarea
              rows="1"
              value={selectedUnitIds.join(", ")}
              readOnly
              className="border rounded w-full p-1 text-xs"
            ></textarea>
            <div>
              <button
                className="rounded overflow-x-auto px-2 py-1 text-sm text-blue-600 hover:bg-blue-100"
                type="button"
                onClick={() => {
                  this.setState({ selectedUnitIds: [] });
                }}
              >
                Clear
              </button>
            </div>
            <div className="w-24">
              <ClickToCopyWrapper
                copyText={selectedUnitIds.join(", ")}
              ></ClickToCopyWrapper>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UnitsCheckSummaryTable;
